import {computed} from 'vue';
import {storeToRefs} from 'pinia';
import {useAuth} from '#imports';

export type ServiceLevel = 'STARTER' | 'ADVANCED' | 'ENTERPRISE';

export function useUserInfo() {
    const authStore = useAuth();
    const {user} = storeToRefs(authStore);

    const serviceLevel = computed<ServiceLevel>(() => {
        switch (user.value?.extraInformation?.serviceLevel) {
            case 'STANDARD':
                return 'STARTER';
            case 'ADVANCED':
                return 'ADVANCED';
            case 'CORPORATE':
                return 'ENTERPRISE';
        }
        return 'STARTER';
    });

    const hasAccessToAISearch = computed<boolean>(() => authStore.currentIdentityHasAccessTo('AI_SEARCH'));

    return {
        serviceLevel,
        hasAccessToAISearch,
    };
}
